import { FC, useMemo } from 'react';

import { ShiftPlanningShift } from '../../../../@paco/entities/Shift/Shift';
import { ShiftPlanning } from '../../../../@paco/entities/ShiftPlanning/ShiftPlanning';
import { ShiftPlanningUser } from '../../../../@paco/entities/User/User';
import { capitalizeFirstLetter } from '../../../../helpers';
import { formatDate } from '../../../../helpers/date';
import UserProfileInfo from '../../../UserProfileInfo/UserProfileInfo';

import './ExchangeShiftInfo.scss';

interface ExchangeShiftInfoProps {
    shift: ShiftPlanningShift;
    shiftPlanning: ShiftPlanning;
    user: ShiftPlanningUser;
}

const ExchangeShiftInfo: FC<ExchangeShiftInfoProps> = ({ shift, shiftPlanning, user }) => {
    const department = shift?.department?.name;
    const group = shift?.department?.departmentGroup?.name;
    const experience = user?.experience?.name;
    const { end, start } = shiftPlanning.period;
    const startDate = useMemo(() => (start ? capitalizeFirstLetter(formatDate(start, 'EEEE d MMMM yyyy')) : ''), [start]);
    const startTime = useMemo(() => (start ? formatDate(start, 'H:mm') : ''), [start]);
    const endTime = useMemo(() => (end ? formatDate(end, 'H:mm') : ''), [end]);

    return (
        <div className="exc-shift-info">
            <UserProfileInfo
                className="exc-shift-info__user-info"
                group={group}
                date={start}
                experience={experience}
                name={user.fullName}
                department={department}
                userId={user.id}
            />
            <div className="exc-shift-info__start-end-time">
                <div className="exc-shift-info__date">
                    {startDate}
                </div>
                <div className="exc-shift-info__time">
                    {`${startTime} - ${endTime}`}
                </div>
            </div>
        </div>
    );
};

export default ExchangeShiftInfo;
